<p *ngIf="endDeviceType">
  {{endDeviceType.Name}}
</p>
